import { render, staticRenderFns } from "./station_anchor_wincc.vue?vue&type=template&id=2af0d126&scoped=true"
import script from "./station_anchor_wincc.vue?vue&type=script&lang=js"
export * from "./station_anchor_wincc.vue?vue&type=script&lang=js"
import style0 from "./station_anchor_wincc.vue?vue&type=style&index=0&id=2af0d126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0d126",
  null
  
)

export default component.exports